import { Middleware } from 'redux'
import persistingMiddleware from './persistingMiddleware'

const coreMiddleware: Middleware[] = [
    persistingMiddleware,
]

export default coreMiddleware
